import { exportReportPdfFromExcelBlob } from "./exportReportPdfFromExcelBlob";

/** Column order matches backend outward Excel export. */
export const OUTWARD_EXPORT_HEADERS = [
  "Transaction ID",
  "Indent Ref",
  "Invoice Number",
  "Invoice Date",
  "Primary Company",
  "Secondary Company",
  "Vehicle",
  "Vehicle Temperature",
  "Dock Number",
  "Dock In Time",
  "Dock Out Time",
  "Product Temperature",
  "Reporting Date",
  "Reporting Time",
  "Dispatch Date",
  "Status",
  "Customer SKU Code",
  "Product Description",
  "Dispatch Qty",
  "Method",
  "Batch Number",
  "Mfg Date",
  "Expiry Date",
  "Batch Qty",
  "Item Status",
];

export async function exportOutwardReportPdfFromExcelBlob(excelBlob, filename) {
  return exportReportPdfFromExcelBlob(
    excelBlob,
    filename,
    OUTWARD_EXPORT_HEADERS
  );
}
